export function formatTicketNumber(ticketNumber: number | null): string | null {
    return ticketNumber === null ? null : `№\u00A0${ticketNumber}`;
}
